module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("vux2 和 Vue 官方 webpack 模板区别是什么？")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("vux2")]), _vm._v(" 模板 fork 自 "), _c('code', [_vm._v("webpack")]), _vm._v(" 模板并进行了配置，和 "), _c('code', [_vm._v("webpack")]), _vm._v(" 模板基本同步，因此建议直接使用 vux2 模板。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-493fa299", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-493fa299"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/difference-between-vux-template-and-webpack-template-42.vue
// module id = 2212
// module chunks = 446